namespace advisorop.components.advisor {

    export class DmsEsignatureController {
        // bindings
        accountId: number;
        custodianAccountId: number;
        investor: domains.IInvestor;
        eSigDocGroupDocuments: domains.IDmsDocument[];
        dgESigDocuments: DevExpress.ui.dxDataGridOptions;

        dxAddToESignatureCheckboxOptions: DevExpress.ui.dxCheckBoxOptions;
        enableAddSelectedFilesToESignature: boolean = false;
        includeFormCRS: boolean = true;

        allAvailableDocs: boolean = false;

        sendingEsignatureLadda: boolean = false;
        creatingAgreementLadda: boolean = false;

        isLoading: boolean = false;

        user: domains.identity.IUser;

        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#dmsEsignatureBody" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading Documents...",
            bindingOptions: {
                visible: "vm.isLoading"
            },
            onShown: function () {
            },
            onHidden: function () {
            }
        };
        eSigInterfaces: domains.IAFExtinterface[];
        selESigInterface: domains.ExternalSystem;
        eSigAvailable: boolean = false;
        eSigLabel: string = null;
        eSigShowRadio: boolean = false;

        static $inject = ["advisorService", "generalService", "identityService", "accountApi", "$scope"];
        constructor(
            private advisorService: advisorop.services.AdvisorService,
            private generalService: advisorop.services.GeneralService,
            private identityService: services.IdentityService,
            private accountApi: services.AccountApi,
            private $scope: ng.IScope
        ) {

            this.dgESigDocuments = {
                export: {
                    enabled: false,
                    fileName: "ESignatureDocuments"
                },
                bindingOptions: {
                    dataSource: "vm.eSigDocGroupDocuments",
                    "columns[1].visible": "vm.allAvailableDocs"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                //paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: true,
                noDataText: "No Documents",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { caption: "Add to E-Signature", dataType: "boolean", cellTemplate: "addToESignature", visible: true, width: 100 },
                    { dataField: "relationDescription", caption: "Account", width: 150 },
                    { dataField: "documentTypeDesc", caption: "Document Type", width: 225 },
                    { dataField: "dateCreated", caption: "Date Uploaded", dataType: "date", width: 100 },
                    { dataField: "documentDate", caption: "Document Date", dataType: "date", width: 100 },
                    { dataField: "version", caption: "Ver.", width: 40 },
                    { dataField: "extension", caption: "Ext.", width: 40 },
                    { dataField: "id", caption: "Actions", cellTemplate: "envColActions", alignment: "left", width: 100 },
                    //{ dataField: "latestEsignatureIdentifierString", caption: "Envelope Id", allowEditing: false},
                    { dataField: "latestEsignatureStatus", caption: "E-Signature Status", width: 120 },
                    { dataField: "latestEsignatureUpdate", caption: "Status Date", dataType: "date", cellTemplate: "latestUpdateDate", width: 120 },
                ],
                masterDetail: {
                    enabled: false,
                },
            };

            this.dxAddToESignatureCheckboxOptions = {
                bindingOptions: {
                    // Created, Sent and Delivered are Docusign statuses
                    // Authoring, Sent and Out For Signature are Adobesign statuses
                    disabled: "envDoc.data.signedDocumentType||envDoc.data.latestEsignatureStatus=='Created'||envDoc.data.latestEsignatureStatus=='Sent'||envDoc.data.latestEsignatureStatus=='Delivered'||envDoc.data.latestEsignatureStatus=='Authoring'||envDoc.data.latestEsignatureStatus=='Out For Signature'",
                    value: "envDoc.data.addToESignature"
                },
                onValueChanged: e => {
                    this.addToESignatureSelectionChanged();
                }
            }

            this.$scope.$watch("vm.accountId", () => {
                if (this.accountId > 0) {
                    this.getESignatureExtInterfaces(this.accountId, null);
                    this.loadESigDocuments();
                }
            });

            this.$scope.$watch("vm.custodianAccountId", () => {
                if (this.custodianAccountId > 0) {
                    this.getESignatureExtInterfaces(this.custodianAccountId, null);
                    this.loadESigDocuments();
                }
            });

        }

        addToESignatureSelectionChanged() {
            this.enableAddSelectedFilesToESignature = this.eSigDocGroupDocuments.filter(d => { return d.addToESignature }).length > 0;
        }

        sendToESignature(): void {
            var docs: domains.IDmsDocument[] = this.eSigDocGroupDocuments.filter(f => f.addToESignature == true);
            if (docs == null || docs.length == 0) {
                toastr.error("You have not selected any documents to send for E-Signature.");
                return;
            }

            var str = "document";
            if (docs.length > 1)
                str = "documents";
            var msg = "You are about to send the selected " + str + " to " + this.eSigLabel;
            if (this.includeFormCRS == true)
                msg += "\n\nForm CRS will be added as the first document.";
            msg += "\n\nAre You Sure ? ";

            if (window.confirm(msg)) {
                // send the account Id and list of selected documents to the server
                var docs: domains.IDmsDocument[] = this.eSigDocGroupDocuments.filter(f => f.addToESignature == true);
                if (docs == null || docs.length == 0) {
                    toastr.error("You have not selected any documents to send for E-Signature.");
                    return;
                } else {
                    this.sendingEsignatureLadda = true;

                    // Build the structure to send to server:
                    var setupOptions: domains.IESigDocumentGroupSettings = { eSignatureSystem: this.selESigInterface, includeFormCRS: this.includeFormCRS };
                    var bulkSetupModel: domains.IESignatureBulkSetupModel = {
                        eSigDocumentGroupSettings: setupOptions,
                        eSigDocumentGroupDocuments: []
                    };

                    // Add documents
                    var docKeys: domains.IDmsDocumentKey[] = [];
                    docs.forEach((element) => {
                        var docKey: domains.IDmsDocumentKey = { documentRelation: domains.DocumentRelation.ACCOUNT, accountId: element.relationId, documentId: element.id, version: element.version }
                        docKeys.push(docKey);
                    });
                    if (docKeys.length > 0) {
                        var envSetup: domains.IESigDocumentGroupDocuments = {
                            docsToSend: docKeys
                        };
                        bulkSetupModel.eSigDocumentGroupDocuments.push(envSetup);
                        var docuSignWind: Window;
                        //console.log("BULK SETUP MODEL:", bulkSetupModel);
                        this.advisorService.addToESignature(bulkSetupModel).then(response => {
                            //if (bulkSetupModel.eSigDocumentGroupSettings.eSignatureSystem == domains.ExternalSystem.DOCUSIGN) {
                            //    docuSignWind = window.open(response.data, "_blank");
                            //} else {
                            //    str = "document has";
                            //    if (docs.length > 1)
                            //        str = "documents have";
                            //    toastr.success(str + " been added to your Adobe Sign DRAFT queue.");
                            //}
                            docuSignWind = window.open(response.data, "_blank");
                        },
                            err => this.generalService.showError(err)
                        ).finally(() => {
                            this.sendingEsignatureLadda = false;
                            this.loadESigDocuments();
                        });
                    }
                }
            } else {
                return;
            }
        }

        eSigInterfaceChanged(): void {
            this.eSigLabel = this.eSigInterfaces.filter(w => w.extinterface == this.selESigInterface)[0].extinterfaceDescription;
        }

        // Determine the E-Signature platform(s) that are available.
        getESignatureExtInterfaces(acctId: number, invId: number): void {
            if (acctId > 0) {
                this.advisorService.getESigExtInterfacesForAccount(acctId)
                    .then(response => {
                        this.eSigInterfaces = response.data;
                        if (this.eSigInterfaces.length > 0) {
                            this.selESigInterface = this.eSigInterfaces[0].extinterface;
                            this.eSigInterfaceChanged();
                            this.eSigAvailable = true;
                            if (this.eSigInterfaces.length > 1)
                                this.eSigShowRadio = true;
                            else
                                this.eSigShowRadio = false;
                        } else {
                            this.eSigAvailable = false;
                        }
                    }, err => this.generalService.showError(err));
            } else if (invId > 0) {
                this.advisorService.getESigExtInterfacesForAdvisor()
                    .then(response => {
                        this.eSigInterfaces = response.data                        
                        if (this.eSigInterfaces.length > 0) {
                            this.selESigInterface = this.eSigInterfaces[0].extinterface;
                            this.eSigInterfaceChanged();
                            this.eSigAvailable = true;
                            if (this.eSigInterfaces.length > 1)
                                this.eSigShowRadio = true;
                            else
                                this.eSigShowRadio = false;
                        } else {
                            this.eSigAvailable = false;
                        }
                    }, err => this.generalService.showError(err));
            }
        }

        loadESigDocuments(): void {
            //console.log("Loading documents for envelopes.... Account:", this.accountId, " Investor:", this.investor);
            if (this.accountId > 0) {
                this.isLoading = true;
                this.advisorService.getAccountDocumentation(this.accountId, false, false, this.custodianAccountId, true, this.allAvailableDocs)
                    .then(response => {
                        this.eSigDocGroupDocuments = response.data;
                        this.eSigDocGroupDocuments.sort((a, b) => a.documentTypeDesc < b.documentTypeDesc ? -1 : a.documentTypeDesc > b.documentTypeDesc ? 1 : 0)
                        this.addToESignatureSelectionChanged(); // reset
                        //console.log("DOCUMENTS:", this.eSigDocGroupDocuments);
                    }, err => this.generalService.showError(err)).finally(() => {
                        this.isLoading = false;
                    });
            } else if (this.investor && this.investor.id > 0) {
                this.isLoading = true;
                this.advisorService.getInvestorDocumentation(this.investor.id, false, false)
                    .then(response => {
                        this.eSigDocGroupDocuments = response.data;
                        this.eSigDocGroupDocuments.sort((a, b) => a.documentTypeDesc < b.documentTypeDesc ? -1 : a.documentTypeDesc > b.documentTypeDesc ? 1 : 0)
                        this.addToESignatureSelectionChanged(); // reset
                    }, err => this.generalService.showError(err)).finally(() => {
                        this.isLoading = false;
                    });
            }
        }

        resetDocusignEnvelopeStatus(accountId: number, envDoc: any): void {

            envDoc.ladda = true

            if (window.confirm("You are about to reset the Docusign envelope status for this document and any other documents in the same envelope as this document. Are you sure?")) {
                this.advisorService.resetDocusignEnvelopeStatus(accountId, envDoc.latestEsignatureIdentifierString).then(
                    response => {
                        toastr.success("Docusign status has been reset.");
                        this.loadESigDocuments();
                    },
                    err => this.generalService.showError(err)
                ).finally(() => {
                    envDoc.ladda = false;
                });
            } else {
                envDoc.ladda = false;
            }
        }


        // overrides
        $onChanges(evt): void {
            for (var key in evt) {
                if ((key == "accountId" && this.accountId > 0) || (key == "custodianAccountId" && this.custodianAccountId > 0) || (key == "investor" && this.investor && this.investor.id > 0)) {
                    if (key == "accountId" && this.accountId > 0) {
                        this.getESignatureExtInterfaces(this.accountId, null);
                    } else if (key == "custodianAccountId" && this.custodianAccountId > 0) {
                        this.getESignatureExtInterfaces(this.custodianAccountId, null);
                    } else if (key == "investor" && this.investor && this.investor.id > 0) {
                        this.getESignatureExtInterfaces(null, this.investor.id);
                    }

                    this.loadESigDocuments();
                }
            }
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
            });
        }
    }

    class DmsEsignature implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                accountId: "<",
                custodianAccountId: "<",
                investor: "<",
            };
            this.controller = DmsEsignatureController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/dms-esignature.html";
        }

    }
    angular.module(Constants.APP).component("dmsEsignature", new DmsEsignature());
}